import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "./Feature.css";
import Footer from "../../Footer/Footer";

const SearchProduct = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({
    color: [],
    size: [],
    brand: [],
    service: [],
  });
  const [availableColors, setAvailableColors] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [availableBrands, setAvailableBrands] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedCategoryId = queryParams.get("category_id");
  const selectedCategoryName = queryParams.get("category_name");
  const searchQuery = queryParams.get("search");

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://dehleze.shop/product-create/")
      .then((response) => {
        const allProducts = response.data;
        setProducts(allProducts);

        const uniqueColors = [
          ...new Set(
            allProducts.map((p) => p.color?.toLowerCase()).filter(Boolean)
          ),
        ];
        const uniqueSizes = [
          ...new Set(
            allProducts.map((p) => p.size?.toLowerCase()).filter(Boolean)
          ),
        ];
        const uniqueBrands = [
          ...new Set(
            allProducts.map((p) => p.brand?.toLowerCase()).filter(Boolean)
          ),
        ];
        const uniqueServices = [
          ...new Set(
            allProducts.map((p) => p.service?.toLowerCase()).filter(Boolean)
          ),
        ];

        setAvailableColors(uniqueColors);
        setAvailableSizes(uniqueSizes);
        setAvailableBrands(uniqueBrands);
        setAvailableServices(uniqueServices);

        if (searchQuery) {
          setSearchTerm(searchQuery);
          const searchFiltered = allProducts.filter((product) =>
            product.name.toLowerCase().includes(searchQuery.toLowerCase())
          );
          setFilteredProducts(searchFiltered);
        } else if (selectedCategoryId) {
          if (selectedCategoryName) setCategoryName(selectedCategoryName);
          const categoryFiltered = allProducts.filter(
            (product) => String(product.category_Id) === selectedCategoryId
          );
          setFilteredProducts(categoryFiltered);
        } else {
          setFilteredProducts(allProducts);
        }

        setTimeout(() => {
          setLoading(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setLoading(false);
      });
  }, [searchQuery, selectedCategoryId, selectedCategoryName]);

  const handleCheckboxChange = (filterType, value) => {
    const updatedFilters = { ...selectedFilters };
    const currentValues = new Set(updatedFilters[filterType]);

    if (currentValues.has(value)) {
      currentValues.delete(value);
    } else {
      currentValues.add(value);
    }

    updatedFilters[filterType] = Array.from(currentValues);
    setSelectedFilters(updatedFilters);
    applyFilters(updatedFilters);
  };

  const applyFilters = (filters) => {
    const filtered = products.filter((product) => {
      const matchesSearch = product.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      const matchesColor =
        filters.color.length === 0 ||
        (product.color && filters.color.includes(product.color.toLowerCase()));

      const matchesSize =
        filters.size.length === 0 ||
        (product.size && filters.size.includes(product.size.toLowerCase()));

      const matchesBrand =
        filters.brand.length === 0 ||
        (product.brand && filters.brand.includes(product.brand.toLowerCase()));

      const matchesService =
        filters.service.length === 0 ||
        (product.service &&
          filters.service.includes(product.service.toLowerCase()));

      return (
        matchesSearch &&
        matchesColor &&
        matchesSize &&
        matchesBrand &&
        matchesService
      );
    });

    setFilteredProducts(filtered);
  };

  const getProductImage = (product) => {
    return (
      product?.color_image?.replace(
        "http://39.61.51.195:8004/",
        "https://dehleze.shop/"
      ) ||
      product?.product_image?.replace(
        "http://39.61.51.195:8004/",
        "https://dehleze.shop/"
      ) ||
      (product?.images?.[0]?.image &&
        product.images[0].image.replace(
          "http://39.61.51.195:8004/",
          "https://dehleze.shop/"
        )) ||
      "https://via.placeholder.com/150"
    );
  };

  const handleViewDetails = (productId) => {
    navigate(`/product/${productId}`);
  };

  const calculateDiscountedPrice = (price, discount) => {
    if (!discount || discount === 0) return price.toFixed(2);
    const discountedAmount = price - price * (discount / 100);
    return discountedAmount.toFixed(2);
  };

  const truncateProductName = (name) => {
    const words = name.split(" ");
    return words.length > 3 ? words.slice(0, 3).join(" ") + "..." : name;
  };

  return (
    <div className="container-fluid p-3">
      <div className="row">
        {/* Sidebar Filters */}
        <div className="col-12 col-md-3 mb-4">
          <h4>Filter Products</h4>

          <div className="mb-3">
            <strong>Color</strong>
            {availableColors.map((color) => (
              <div key={color}>
                <label>
                  <input
                    type="checkbox"
                    value={color}
                    checked={selectedFilters.color.includes(color)}
                    onChange={() => handleCheckboxChange("color", color)}
                    style={{ marginRight: "8px" }}
                  />
                  {color.charAt(0).toUpperCase() + color.slice(1)}
                </label>
              </div>
            ))}
          </div>

          <div className="mb-3">
            <strong>Size</strong>
            {availableSizes.map((size) => (
              <div key={size}>
                <label>
                  <input
                    type="checkbox"
                    value={size}
                    checked={selectedFilters.size.includes(size)}
                    onChange={() => handleCheckboxChange("size", size)}
                    style={{ marginRight: "8px" }}
                  />
                  {size.toUpperCase()}
                </label>
              </div>
            ))}
          </div>

          <div className="mb-3">
            <strong>Brand</strong>
            {availableBrands.map((brand) => (
              <div key={brand}>
                <label>
                  <input
                    type="checkbox"
                    value={brand}
                    checked={selectedFilters.brand.includes(brand)}
                    onChange={() => handleCheckboxChange("brand", brand)}
                    style={{ marginRight: "8px" }}
                  />
                  {brand.toUpperCase()}
                </label>
              </div>
            ))}
          </div>

          <div className="mb-3">
            <strong>Service</strong>
            {availableServices.map((service) => (
              <div key={service}>
                <label>
                  <input
                    type="checkbox"
                    value={service}
                    checked={selectedFilters.service.includes(service)}
                    onChange={() => handleCheckboxChange("service", service)}
                    style={{ marginRight: "8px" }}
                  />
                  {service.toUpperCase()}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Products Display */}
        <div className="col-12 col-md-9">
          {filteredProducts.length > 0 ? (
            <div className="row">
              {filteredProducts.map((product) => (
                <div key={product.id} className="col-6 col-sm-4 col-md-3 mb-3">
                  <div
                    className="product-card featureproduct-card d-flex flex-column justify-content-between"
                    style={{
                      width: "90%",
                      margin: "0 auto",
                      height: "270px",
                      // padding: "10px",
                      boxSizing: "border-box",
                    }}
                  >
                    {product?.discount_percentage > 0 && (
                      <div
                        className="badge bg-danger position-absolute"
                        style={{ top: 10, left: 10 }}
                      >
                        -{product.discount_percentage}%
                      </div>
                    )}
                    <img
                      src={getProductImage(product)}
                      alt={product.name}
                      className="img-fluid rounded"
                      style={{ height: "130px", objectFit: "cover" }}
                    />
                    <div className="text-center">
                      <h6
                        style={{
                          fontSize: "0.65rem",
                          height: "1.3em",
                          overflow: "hidden",
                          marginTop: "-5%",
                        }}
                      >
                        {truncateProductName(product.name)}
                      </h6>
                      <p
                        className="text-danger mb-1"
                        style={{ fontSize: "0.6rem" }}
                      >
                        <del>PKR {product.price}</del> <br />
                        PKR{" "}
                        {calculateDiscountedPrice(
                          product.price,
                          product.discount_percentage
                        )}
                      </p>
                      <p
                        className="text-success fw-semibold"
                        style={{ fontSize: "0.65rem" }}
                      >
                        Delivery on Cash
                      </p>
                      <button
                        className="btn btn-warning w-100 btn-sm"
                        onClick={() => handleViewDetails(product.id)}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : loading ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ height: "60vh" }}
            >
              <div className="spinner-border text-warning" role="status"></div>
              <p className="mt-3">Loading products...</p>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "60vh" }}
            >
              <p className="fs-5 fw-semibold">No product match</p>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SearchProduct;
